import UserEdit from "./edit.vue";
import UserList from './list.vue'
import recordList from './recordlist.vue'
import UserEditPassword from "./edit/password.vue";
let a = Object.assign({UserEdit, UserList, UserEditPassword,recordList})
export default a;
